import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DialogModule } from '@progress/kendo-angular-dialog';
import { GridModule } from '@progress/kendo-angular-grid';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';

import { EmailDomainValidator } from './directives/email-domain-validator.directive';
import { AtLeastOneDirective } from './directives/at-least-one.directive';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { StudentCampaignGridsComponent } from './student-campaign-grids.component';
import { FormatPhonePipe } from './pipes/format-phone-pipe';
import { TruncateTextPipe } from './pipes/truncate-text-pipe';
import { ClCommonAngularModule } from 'cl-common-angular';
import { CampaignCompleteEditComponent } from './components/campaign-complete-edit.component';

@NgModule({
    declarations: [
        EmailDomainValidator,
        AtLeastOneDirective,
        AutoFocusDirective,
        FormatPhonePipe,
        TruncateTextPipe,
        StudentCampaignGridsComponent,
        CampaignCompleteEditComponent
    ],
    exports: [
        EmailDomainValidator,
        AtLeastOneDirective,
        AutoFocusDirective,
        FormatPhonePipe,
        TruncateTextPipe,
        StudentCampaignGridsComponent,
        CampaignCompleteEditComponent,
        ClCommonAngularModule,
        DateInputsModule,
        FormsModule,
        ReactiveFormsModule,
        CurrencyPipe
    ],
    imports: [
        CommonModule,
        FormsModule,
        DialogModule,
        GridModule,
        ClCommonAngularModule,
        DateInputsModule,
        FormsModule,
        ReactiveFormsModule
    ],
    providers: [
        DatePipe
    ],
})
export class SharedModule { }
